import { render, staticRenderFns } from "./cardCarrierStatus.vue?vue&type=template&id=50bd2c4c&scoped=true&"
import script from "./cardCarrierStatus.vue?vue&type=script&lang=js&"
export * from "./cardCarrierStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bd2c4c",
  null
  
)

export default component.exports